import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import HospitalVisitSelect from './HospitalVisitSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import DataGridClickedPopup from '../../../component/common/popup/DataGridClickedPopup.jsx';

const TrmsAgeGender = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30 + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("useremcd") : '',
        searchGrdc: '',
        searchCheck1: '',
        searchCheck2: '1',
    });

    const [desc, setDesc] = useState('');

    const searchParamsAdditional = {
        userAuth: localStorage.getItem("userAuth"),
        userEmcd: localStorage.getItem("useremcd"),
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = [['기관명', '내원 현황', '내원 현황', '내원 현황', '119 직접내원율', '응급진료결과', '응급진료결과', '응급진료결과', '응급진료결과', '최종수용환자의 전원율', '사망률'], ['기관명', '외상환자 수', '중증외상환자 수', '중증외상환자 비율', '119 직접내원율', '귀가', '전원', '입원', '사망', '최종수용환자의 전원율', '사망률']]; //component화 
    const dataColumn = ['TRMSEMNM', 'TRMS_CNT', 'STRM_CNT', 'STRM_RATE', 'INRTMN1_RATE', 'EMRT10', 'EMRT20', 'EMRT30', 'EMRT40', 'JUNWON_RATE', 'DEATH_RATE'];
    const apiCall = '/trmsapi/hospitalvisit/bdtongtrms_stat_of_hospital_visit_search.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_외상환자 내원현황`;
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const popupPropsInfo = {
        checked: ["JUNWON", "DEATH"],
        localStorageName: 'incurrData',
        popupAddress: "/nedis/trmsInfo/trms_incurr_popup.do",
    }

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="10%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <HospitalVisitSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setDesc={setDesc}
                            />
                        </tr>
                        <tr>
                            <th>환자분류</th>
                            <td>
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="2">응급센터</option>
                                    <option value="1">외상센터</option>
                                </select>
                            </td>
                            <th>중증도</th>
                            <td>
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    <option value="1">전체</option>
                                    <option value="2">중증외상</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <DataGridClickedPopup
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                searchParams={searchParams}
                popupPropsInfo={popupPropsInfo}
                ver='trmsVisit'
            />
            <p>* 외상등록체계 전송 대상자 중 ‘외상환자 제외’ 및 ‘연동 후 제외’, ‘외상 삭제’ 제외<br />
                * 중증외상환자: [최종 ISS] 15점 초과인 환자<br />
                * 119 직접 내원율: [내원경로]가 ‘직접 내원’이면서 [내원수단]이 ‘119 구급차’인 환자의 비율<br />
                * 최종 수용 환자의 전원율: 최종 수용 대상인 환자 중 전원 환자의 비율<br />
                &ensp;&nbsp;- 최종 수용 대상: 전체 환자 중 [응급진료결과]가 ‘귀가(13)’ 또는 ‘사망(41,42,43)’인 환자 제외<br />
                &ensp;&nbsp;- 전원 환자: [응급진료결과]가 ‘전원’이거나 내원에서 퇴원까지 소요시간이 24시간 이내인 입원환자 중 [입원 후 결과] ‘전원’인 환자<br />
                * 사망률: 전체 환자 중 사망한 환자의 비율<br />
                &ensp;&nbsp;- 사망 환자: [응급진료결과]가 ‘사망’이거나 입원환자 중 [입원 후 결과]가 ‘사망’인 환자</p>
        </Main>
    )
}

export default TrmsAgeGender;